import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { ResultsContainerData } from "./types";

export const disableClientRender = true;

export const setCustomAttributes = ({
  variables,
}: WidgetContext<ResultsContainerData>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export function getServerProps({
  props,
}: WidgetContext<ResultsContainerData>): ResultsContainerData {
  return props;
}

export default function ResultsContainer({
  props,
  ...rest
}: WidgetContext<ResultsContainerData>) {
  log({ props, ...rest });

  const { ssi: ssiList } = props.data?.getSdapiResultsContainerWidget || {};

  return (
    <>
      {ssiList?.map((ssi, i) => (
        <div
          key={ssi! + i}
          data-include={ssi}
          dangerouslySetInnerHTML={{
            __html: `<!--#include virtual="${ssi}" -->`,
          }}
        />
      ))}
    </>
  );
}
